var validateCpf = require('iscpf');
var isCpf = function isCpf(cpf) {
  return cpf ? !cpf.replace(/[._-]+/gi, '').match(/^(.)\1+$/) && validateCpf(cpf) : true;
};
module.exports = isCpf;
var isCpfForField = function isCpfForField(cpf) {
  return cpf ? !cpf.replace(/[._-]+/gi, '').match(/^(.)\1+$/) && validateCpf(cpf) || cpf.length < 14 : true;
};
module.exports = isCpfForField;